<template>
  <medium-g><hr /></medium-g>
</template>
